import { Reveal, SectionHeading } from "./Reveal";

const TERMINAL_LINES = [
  { cmd: "whoami", out: "luiz_henrique — desenvolvedor web" },
  { cmd: "stack --principal", out: "react · next.js · node · tailwind" },
  { cmd: "foco --areas", out: "sites empresariais & sites de games" },
  { cmd: "missao --atual", out: "transformar visitantes em clientes" },
];

const MANIFESTO = [
  {
    n: "01",
    title: "Velocidade é identidade",
    text: "Um site lento perde cliente antes mesmo de carregar. Cada projeto meu nasce otimizado para carregar em menos de 1 segundo.",
  },
  {
    n: "02",
    title: "Design que converte",
    text: "Não crio apenas páginas bonitas — desenvolvo armas de conversão visual, onde cada elemento guia o visitante para a ação.",
  },
  {
    n: "03",
    title: "Do corporativo ao gamer",
    text: "A mesma precisão técnica aplicada a dois universos: a autoridade que uma empresa precisa e a imersão que um jogo merece.",
  },
];

const STATS = [
  ["20+", "Sites entregues"],
  ["100%", "Taxa de satisfação"],
  ["99+", "Score no PageSpeed"],
  ["<1s", "Tempo de carregamento"],
];

export const About = () => {
  return (
    <section id="sobre" className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
      <SectionHeading
        number="01"
        label="Sobre mim"
        title="Código limpo."
        accent="Resultado bruto."
      />

      <div className="mt-16 grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
        <div className="space-y-10">
          <Reveal>
            <p className="text-base leading-relaxed text-zinc-400 sm:text-lg">
              Sou <span className="font-semibold text-zinc-100">Luiz Henrique</span>, desenvolvedor
              web focado em criar presenças digitais que impressionam e vendem. Trabalho no
              desenvolvimento de <span className="text-zinc-200">sites para empresas</span> que
              precisam de autoridade e de <span className="text-zinc-200">plataformas para
              estúdios de jogos e eSports</span> que precisam de impacto visual extremo.
            </p>
          </Reveal>

          <div className="space-y-0 border-t border-[#1A1A20]">
            {MANIFESTO.map((item, i) => (
              <Reveal key={item.n} delay={i * 0.1}>
                <div
                  data-testid={`manifesto-item-${item.n}`}
                  className="group grid grid-cols-[64px_1fr] gap-4 border-b border-[#1A1A20] py-6 transition-colors duration-300 hover:bg-[#0A0A0C]"
                >
                  <span className="font-display text-xl font-extrabold text-[#E50914]/70 transition-colors group-hover:text-[#E50914]">
                    {item.n}
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-bold text-zinc-100">{item.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-zinc-500">{item.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="space-y-8">
          <Reveal delay={0.15}>
            <div
              data-testid="about-terminal"
              className="card-glow overflow-hidden rounded-2xl border border-[#22222A] bg-[#0A0A0C]"
            >
              <div className="flex items-center gap-2 border-b border-[#1A1A20] bg-[#101014] px-5 py-3.5">
                <span className="h-3 w-3 rounded-full bg-[#E50914]" />
                <span className="h-3 w-3 rounded-full bg-zinc-700" />
                <span className="h-3 w-3 rounded-full bg-zinc-700" />
                <span className="ml-3 font-mono-code text-xs text-zinc-500">luiz@dev: ~</span>
              </div>
              <div className="space-y-4 p-6 font-mono-code text-sm">
                {TERMINAL_LINES.map((line) => (
                  <div key={line.cmd}>
                    <div className="text-zinc-500">
                      <span className="text-[#E50914]">$</span> {line.cmd}
                    </div>
                    <div className="mt-1 text-zinc-300">
                      <span className="text-[#E50914]">&gt;</span> {line.out}
                    </div>
                  </div>
                ))}
                <div className="text-zinc-500">
                  <span className="text-[#E50914]">$</span> status
                  <span className="terminal-caret ml-1 inline-block h-4 w-2 translate-y-0.5 bg-[#E50914]" />
                </div>
                <div className="mt-1 text-zinc-300">
                  <span className="text-[#E50914]">&gt;</span> disponível para novos projetos{" "}
                  <span className="status-dot ml-1 inline-block h-2 w-2 rounded-full bg-[#E50914]" />
                </div>
              </div>
            </div>
          </Reveal>

          <div className="grid grid-cols-2 gap-4">
            {STATS.map(([num, label], i) => (
              <Reveal key={label} delay={0.1 + i * 0.08}>
                <div
                  data-testid={`about-stat-${i}`}
                  className="card-glow rounded-2xl border border-[#22222A] bg-[#101014] p-6"
                >
                  <div className="font-display text-3xl font-extrabold text-[#E50914]">{num}</div>
                  <div className="mt-2 font-mono-code text-[10px] uppercase tracking-[0.2em] text-zinc-500 sm:text-xs">
                    {label}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
